module.exports = __webpack_public_path__ + "img/watch-card.80aa369f.png";